// src/components/Field.jsx
import React from "react";

export const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  height: 40,
  borderRadius: 4,
  border: "1px solid #E6EDFF",
  background: "#FAFAFB",
  fontSize: 14,
  boxSizing: "border-box",
};

export default function Field({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  type = "text",
  isSelect = false,
  options = [],
}) {
  // Campos que siempre deben mostrarse en rojo
  return (
    <div style={{ flex: 1 }}>
      <label
        style={{
          display: "block",
          marginBottom: 12,
        }}
      >
        {label}
      </label>

      {isSelect ? (
        <select
          name={name}
          value={value}
          onChange={onChange}
          style={inputStyle}
        >
          <option value="">{placeholder}</option>
          {options.map((o) => (
            <option key={o.value ?? o} value={o.value ?? o}>
              {o.label ?? o}
            </option>
          ))}
        </select>
      ) : (
        <input
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={inputStyle}
        />
      )}
    </div>
  );
}
